export default __webpack_public_path__ + "static/media/earth.928d7c60.mp3";